import { Component, OnInit } from '@angular/core';
import { ConsultaService } from '../../services/consulta.service';
import { CategoriasService } from '../../services/categorias.service';
import { Router } from '@angular/router';
import { ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { URL_IMG } from '../../../conf/url.servicios';
import { ActivatedRoute } from '@angular/router';
import { ProductosService } from '../../services/productos.service';

declare var jquery: any;
declare var $: any;
declare var bootbox: any;

class Categoria {
  idMarca: any;
  idImagen: any;
  clave: any;
  nombre: any;
  descripcion: any;
  orden: any;
  id: any;
}

class Item {
  N_CAT_PADRE: any;
  N_ESTATUS: any;
  N_ID: any;
  N_IDIMAGEN: any;
  N_IDMARCA: any;
  N_ORDEN: any;
  S_CLAVE: any;
  S_DESCRIPCION: any;
  S_NOMBRE: any;
  S_RUTA: any;
  claveImg: any;
  descripcionImg: any;
  idImagen: any;
}

class ImagenTabla {
  clave: string;
  descripcion: string;
  ruta: string;
  tipo: number;
  id: number;
}

class RelacionImgMC {
  idImagen: number;
  idMC: number;
}
@Component({
  selector: 'app-administra-categorias',
  templateUrl: './administra-categorias.component.html',
  styleUrls: ['./administra-categorias.component.css']
})
export class AdministraCategoriasComponent implements OnInit {

  idCategoria: any;
  idImg: any;
  itemNew: Categoria;
  extension: any;
  loading: boolean;
  rutaEliminar: any;
  rutaImagen = URL_IMG;
  title = "Administración de Categorías";
  categorias: any = [];
  form: FormGroup;
  itemEdicion: Item;
  idEliminar: any;

  constructor(private router: Router, private fb: FormBuilder, private consultaService: ConsultaService,
    private categoriasService: CategoriasService, private activatedRoute: ActivatedRoute) {
    this.createForm();
  }

  /**
* Image form
*/
  createForm() {
    this.form = this.fb.group({
      name: ['', Validators.required],
      avatar: null,
      carpeta: "categorias"
    });
  }

  ngOnInit() {
    if (!this.consultaService.esNuevaSession()) {
      this.activatedRoute.params.subscribe(params => {
        this.obtieneCategorias(params['idMarca']);
      })
      this.itemEdicion = this.initItem(this.itemEdicion);
      this.itemNew = this.initItem(this.itemNew);
    }
  }

  initItem(item): any {
    item = new Item();
    item.N_CAT_PADRE = "";
    item.N_ESTATUS = "";
    item.N_ID = "";
    item.N_IDIMAGEN = "";
    item.N_IDMARCA = "";
    item.​​N_ORDEN = "";
    item.​​S_CLAVE = "";
    item.​​S_DESCRIPCION = "";
    item.S_NOMBRE = "";
    item.​​S_RUTA = "";
    item.​​claveImg = "";
    item.​​descripcionImg = "";
    item.​​idImagen = "";
    return item;
  }

  initModalEdicion(item) {
    console.log("Item editar");
    console.log(item);
    this.itemEdicion = item;

  }

  obtieneCategorias(idMarca: any) {
    this.categoriasService.obtieneCategorias(idMarca).then(resolve => {
      this.categorias = this.categoriasService.categorias;
    });
  }

  editaProductos(item: any) {
    this.router.navigate(['/administraProductos', item.N_ID]);
  }

  actualizarCategoria() {
    this.categoriasService.actualizarCategoria(this.itemEdicion).then(resolve => {
      this.obtieneCategorias(1);
      bootbox.alert("<strong>Alerta</strong><br/><br/> Datos guardados correctamente");
    });
  }

  initModalNew() {
    this.itemNew = new Categoria();
    this.itemNew.idMarca = 1;
    this.itemNew.idImagen = "";
    this.itemNew.clave = "";
    this.itemNew.nombre = "";
    this.itemNew.descripcion = "";
    this.itemNew.orden = "";
    this.itemNew.id = null;
  }

  cambiarImagen() {
    this.rutaEliminar = this.itemEdicion.S_RUTA;
    this.itemEdicion.S_RUTA = "";
  }

  getNewFileName(formParam) {
    var fileNameAux = formParam.avatar.filename;
    this.extension = fileNameAux.split('.').pop();
    var valReplace = "." + this.extension;
    var newFileName = fileNameAux.replace(valReplace, "");
    return newFileName + Date.now() + "." + this.extension;
  }

  /**
  * File change
  * @param event
  */
  onFileChange(event) {
    let reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.form.get('avatar').setValue({
          filename: file.name,
          filetype: file.type,
          value: reader.result.split(',')[1]
        })
      };
    }
  }

  isValidForm() {
    var valido = true;
    const formModel = this.form.value;

    if (formModel.name.length == 0 || formModel.avatar == null) {
      valido = false;
    }
    return valido;
  }

  guardarCategoria() {
    console.log("Datos Categoria a editar");
    console.log(this.itemNew);

    //Adjunta imagen

    var rutaImagen = "";
    const formModel = this.form.value;
    this.loading = true;
    console.log(formModel);
    formModel.avatar.filename = this.getNewFileName(formModel);
    this.consultaService.guardarImagen(formModel).then(resolve => {
      console.log(resolve);
      if (resolve) {
        rutaImagen = this.consultaService.rutaImagen;
        //Guarda ruta imagen en tabla
        var imgTbl = new ImagenTabla();
        imgTbl.clave = "";
        imgTbl.descripcion = formModel.name;
        imgTbl.ruta = rutaImagen;
        imgTbl.tipo = 1;
        this.consultaService.guardaImagenTabla(imgTbl).then(resolve => {
          this.idImg = this.consultaService.idImg;

          //Guarda blog
          console.log("idImg-->" + this.idImg);
          if (this.itemNew.id == null) {
            console.log("Nuevo");
            console.log(this.itemNew);
            this.itemNew.idImagen = this.idImg;
            this.categoriasService.guardarCategoria(this.itemNew).then(resolve => {
              this.idImg = this.consultaService.idImg;
              this.idCategoria = this.categoriasService.idCategoria;
              //Guarda la relacion imagen-blog
              var rel = new RelacionImgMC();
              rel.idMC = this.idCategoria;
              rel.idImagen = this.idImg;
              this.categoriasService.guardaRelacionImgMC(rel).then(resolve => {
                    this.obtieneCategorias(1);
                    bootbox.alert("<strong>Alerta</strong><br/><br/> Información guardada correctamente");
              });

            });
          }

        });
      } else {
        alert('Ocurrió un error al subir la imagen, favor de intentar nuevamente');
      }

    });
  }

  alertEliminar(item) {
    this.idEliminar = item.N_ID;
    bootbox.confirm("<strong>Alerta</strong><br/><br/>¿Desea eliminar la categoría seleccionada?",
      function (result) {
        if (result) {
          $("#btn_eli_cat").click();
        }
      });
  }

  eliminar() {
    console.log("idEliminar");
    console.log(this.idEliminar);
    this.categoriasService.eliminarCategoria(this.idEliminar).then(resolve => {
      this.obtieneCategorias(1);
      bootbox.alert("<strong>Alerta</strong><br/><br/> Categoría eliminada correctamente");
    });
  }


  actualizarImagen() {

    console.log("Editar");

    //Adjunta imagen

    var rutaImagen = "";
    const formModel = this.form.value;
    this.loading = true;
    console.log(formModel);
    formModel.avatar.filename = this.getNewFileName(formModel);

    //Borra ruta del servidor

    this.consultaService.borraImagen(this.rutaEliminar);

    //adjunta la imagen

    this.consultaService.guardarImagen(formModel).then(resolve => {
      console.log(resolve);
      if (resolve) {

        rutaImagen = this.consultaService.rutaImagen;

        //Guarda ruta imagen en tabla

        var imgTbl = new ImagenTabla();
        imgTbl.clave = "";
        imgTbl.descripcion = formModel.name;
        imgTbl.ruta = rutaImagen;
        imgTbl.tipo = 1;
        imgTbl.id = this.itemEdicion.idImagen;
        this.consultaService.actualizaImagenTabla(imgTbl).then(resolve => {
          bootbox.alert("<strong>Alerta</strong><br/><br/> Información guardada correctamente");

        });
      }
    });

  }

  imagenesMC(item: any){
    console.log(item);
    this.router.navigate(['/administraImgMc', item.S_NOMBRE,item.N_ID]);
  }

}



// WEBPACK FOOTER //
// C:/Users/EZepeda/Desktop/Explora/adminexplora/src/app/components/administra-categorias/administra-categorias.component.ts